import { z } from 'zod';
import type { IsoDate } from './common.js';
import type { UserSummary } from './users.js';

/** Voice/video calls (LiveKit). Every conversation (channel or DM) has at most one live call. */
export interface CallsConfig {
  enabled: boolean;
}

/** Credentials to join the call of a conversation. */
export interface CallJoin {
  /** LiveKit signalling URL (wss://…). */
  url: string;
  token: string;
  channelId: string;
  /** False when the channel's permissions only allow listening (no «Hablar»). */
  canSpeak: boolean;
}

/** A call in progress; `participants` is empty once it has ended. */
export interface ActiveCall {
  channelId: string;
  teamId: string;
  participants: UserSummary[];
  /** Display names of guests who joined through a meeting link. */
  guests: string[];
  startedAt: IsoDate | null;
}

export const callRecordingSchema = z.object({ on: z.boolean() });
export type CallRecordingInput = z.infer<typeof callRecordingSchema>;

/** Largest recording accepted for a summary (the transcription API takes up to 25 MB). */
export const CALL_SUMMARY_MAX_BYTES = 25 * 1024 * 1024;
